<template>
	<div>
		<van-tabs v-model="indexactive" sticky swipeable color=#5f6b80 :border=false title-active-color="#232326" title-inactive-color="#848689">
			<van-tab title="分销广场">
				<van-search v-model="searchValue" show-action shape="round" placeholder="搜索景区/目的地" @search="onSearch" @cancel="onCancel" style="position: fixed;top: 35px;width: 100%;"/>

				<van-dropdown-menu active-color="#5f6b80" class="choice">
					<van-dropdown-item v-model="fenxiao.type" :options="fenxiao.types" @change="typeChange"/>
					<van-dropdown-item v-model="fenxiao.cid" :options="fenxiao.province" @change="cityChange" />
					<van-dropdown-item v-if="fenxiao.type==0" v-model="moneyArea" :options="fenxiao.money" @change="moneyChange" />
					<van-dropdown-item v-else v-model="moneyArea" :options="fenxiao.money2" @change="moneyChange" />
				</van-dropdown-menu>
				<div class="content">
					<!-- <div class="explain"><img src="../../assets/ls_icon_listnoteblue.png">淡旺季价格浮动，分销收益会随之变化。</div> -->
					
					<template v-if="fenxiao.type == 1">
						<div v-if="fenxiao.activityData.length==0">
							<div class="none"><img src="../../assets/icon_msg_failure.png"><p>什么都没有</p></div>
						</div>
						<div class="line" v-for="(item, index) in fenxiao.activityData" :key="index" >
							<div class="left">
								<h1 v-text="item.caption"></h1>
								<div class="bottom">
									<p class="money" v-if="fenxiao.type==1">￥<b v-text="item.salePrice">11300</b>/人</p>
									<span>分销收益</span>
									<p class="num">约¥<b>{{item.distribProfit}}</b>/人</p>
								</div>
							</div>
							<div class="right">
								<div class="btn" @click="goshare(item.id)">去分销</div>
							</div>
						</div>
					</template>
					<template v-else>
						<div v-if="fenxiao.listData.length==0">
							<div class="none"><img src="../../assets/icon_msg_failure.png"><p>什么都没有</p></div>
						</div>
						<div class="line" v-for="(item, index) in fenxiao.listData" :key="index" >
							<div class="left">
								<h1 v-text="item.caption"></h1>
								<div class="bottom">
									<p class="money" v-if="fenxiao.type==1">￥<b v-text="item.salePrice">11300</b>/人</p>
									<span>分销收益</span>
									<p class="num">约¥<b>{{item.distribProfit}}</b>/人</p>
								</div>
							</div>
							<div class="right">
								<div class="btn" @click="gofenxiao(item.id)">去分销</div>
							</div>
						</div>
					</template>
					
					
					<div class="bottom_text" v-if="fenxiao.theEnd"><img src="../../assets/i_img_fxlineleft.png">已经到底了，快去分销赚钱啦<img src="../../assets/i_img_fxlineright.png"></div>
				</div>
			</van-tab>
			<van-tab title="我的收益">
				<div class="profit">
					<img src="../../assets/i_btn_fxcuse.png" @click="goTel('18600041335')">
					<p>累计收益(元)</p>
					<h1>{{profit.endSettle ? profit.endSettle : 0}}</h1>
					<div class="button" @click="goWallet">去提现</div>
					<p>待结算收益{{profit.waitSettle ? profit.waitSettle : 0}}元<img src="../../assets/ls_icon_problem_w.png"  @click="showPopup"></p>
				</div>
				<van-tabs v-model="profitactive" animated :border=false color=#fff title-active-color="#606B80" title-inactive-color="#848689">
					<van-tab title="活动收益">
						<template v-if="activityprofit.list&&activityprofit.list.length">
							<div class="profit_content">
								<div class="line" v-for="(item, index) in activityprofit.list" :key="index" >
									<div class="left">
										<h1>{{item.caption}}</h1>
										<div class="profit_bottom">
											<p>已结算:<span class="money">￥{{item.endSettle}}</span></p>
											<img src="../../assets/i_img_fxline.png">
											<p>待结算:<span class="money">￥{{item.waitSettle}}</span></p>
										</div>
									</div>
									<div class="btn" @click="goInfoDetail('activityprofit', item.id)">查看详情</div>
								</div>
							</div>
							
						</template>
						<template v-else>
							<div class="none"><img src="../../assets/icon_msg_failure.png"><p>什么都没有</p></div>
						</template>
					</van-tab>
					<van-tab title="路书收益">
						<div class="profit_content">
							<template v-if="lineprofit.list && lineprofit.list.length">
								<div class="line" v-for="(item, index) in lineprofit.list" :key="index" >
									<div class="left">
										<h1>{{item.caption}}</h1>
										<div class="profit_bottom">
											<p>已结算:<span class="money">￥{{item.endSettle}}</span></p>
											<img src="../../assets/i_img_fxline.png">
											<p>待结算:<span class="money">￥{{item.waitSettle}}</span></p>
										</div>
									</div>
									<div class="btn" @click="goInfoDetail('lineProfit', item.id)">查看详情</div>
								</div>
							</template>
							<template v-else>
								<div class="none"><img src="../../assets/icon_msg_failure.png"><p>什么都没有</p></div>
							</template>
						</div>
					</van-tab>
					
				</van-tabs>
			</van-tab>
			<van-tab title="客户管理">
				<template v-if="customer.list && customer.list.length">
					<div class="customer">
						<div class="line" v-for="(item, index) in customer.list" :key="index" >
							<img v-if="item.pic" :src="item.pic" >
							<img v-else src="../../assets/ld_img_avatar.png">
							<div class="center">
								<p><b>{{item.nickName}}</b></p>
								<p>累计购买<span>{{item.times}}</span>次</p>
							</div>
							<!-- 暂时注释此功能 -->
							<!-- <div class="btn" @click="goChat(item.uid,item.nickName)">联系TA</div> -->
						</div>
					</div>
				</template>
				<template v-else>
					<div class="none"><img src="../../assets/icon_msg_failure.png"><p>什么都没有</p></div>
				</template>
			</van-tab>
			<van-tab title="分销规则">
				<div class="fenxiao_img"><img src="../../assets/i_img_fxgz.png"></div>
				<van-collapse v-model="activeName" accordion :border="false">
					<van-collapse-item title="1.如何加入分销" name="1">下载阿哈路书APP，申请成为分销商，由阿哈工作人员审核通过后便可分销阿哈平台的线路产品，有客户报名便享受对应分销收益。</van-collapse-item>
					<van-collapse-item title="2.分销规则" name="2">
						<p>分销收益由发布产品的领队制定，分销商可通过后台看到不同产品的代理收益，选择要分销的产品，点击分销便可生成有专属二维码的活动宣传图，可以分享到个人朋友圈、聊天群、论坛等社交渠道，客户扫描图片二维码，可直接进行活动查阅及报名，报名成功便可通过分销商后台查阅到对应订单与收益流水。</p>
						<p>（酒店/门票产生收益的最小限额为50元）</p>
					</van-collapse-item>
					<van-collapse-item title="3.客户管理关系说明" name="3">
						<p>鼓励您发展自己的客户，客户跟您绑定后，此后无论TA购买谁分销的产品，分销收益都归属您。</p>
						<p>客户来源</p>
						<p>①【未注册用户】通过您分销的产品而注册，将成为您的下级；</p>
						<p>②没有上级的【已注册用户】，点击了您分销的产品，将成为您的下级；</p>
						<p>③有上级的【已注册用户】，购买了您分销的产品后，分销收益属于他的上级；</p>
					</van-collapse-item>
					<van-collapse-item title="4.如何提现" name="4">
						<p>为确保客户资金安全，客户如购买酒店、门票等产品，完成消费次日12：00结算收益；如购买活动，活动结束后5~10个工作日结算收益。</p>
						<p>您可以到“我的钱包”进行微信或者支付宝提现。</p>
						</van-collapse-item>
					<van-collapse-item title="5.分销商发展" name="5">
						对于优质分销商，我们将给予更大的发展空间，一方面是代理价的优惠 （优惠部分由阿哈补贴），另一方面则是可升级成为阿哈城市合伙人， 享受对应城市的所有客户收益。
					</van-collapse-item>
				</van-collapse>
			</van-tab>
		</van-tabs>
		
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		DropdownMenu,
		DropdownItem
	} from 'vant';
	Vue.use(DropdownMenu);
	Vue.use(DropdownItem);
	export default {
		data() {
			return {
				versionCode:'',//版本号
				searchValue:'',	//搜索关键词
				indexactive:0,	//顶部选项卡
				profitactive:0,	//我的收益选项卡
				profit:'',	//待结算收益
				activeName:1,	//分销规则百叶窗
				moneyArea: 'default',	//价格排序
				fenxiao:{
					type: 1,
					cid: 'default',
					word:'',
					// value3: 'a',
					types: [{
							text: '活动',
							value: 1,
							// type:2,
						},{
							text: '路书',
							value: 0,
							// type:1,
						},
					],
					province: [{
							text: '出发地',
							value: 'default'
						}
					],
					// 路书下拉列表
					money: [{
							text: '排序',
							value: 'default'
						},
						{
							text: '收益从高到低',
							value: 'desc'
						},
						{
							text: '收益从低到高',
							value: 'asc'
						},
					],
					// 活动下拉列表
					money2: [{
							text: '排序',
							value: 'default'
						},
						{
							text: '本周出发',
							value: 'thisweek'
						},
						{
							text: '下周出发',
							value: 'nextweek'
						},
						{
							text: '端午活动',
							value: 'duanwu'
						},
						{
							text: '收益从高到低',
							value: 'desc'
						},
						{
							text: '收益从低到高',
							value: 'asc'
						},
					],
					listData:[],
					activityData:[],
					page: 1,
					size: 9,
					maxPage: 11,
					theEnd: false,
				},
				lineprofit:{
					page: 1,
					size: 9,
					maxPage: 11,
					theEnd: false,
					list: [],
				},
				activityprofit:{
					page: 1,
					size: 9,
					maxPage: 11,
					theEnd: false,
					list: [],
				},
				customer:{
					page: 1,
					size: 9,
					maxPage: 11,
					theEnd: false,
					list: [],
				},
			};
		},
		computed: {
			token() {
				return this.$store.getters.getToken
			},
			device() {
				return String(this.$store.state.device).toString().toLowerCase()
			},
		},
		mounted() {
			if (this.token.length === 32) {
				var localFenxiao = localStorage.getItem('fenxiao') ? JSON.parse(localStorage.getItem('fenxiao')) : null;
				console.log(localFenxiao);
				if (localFenxiao && localFenxiao.fenxiao.type == 1)
				{
					this.fenxiao.cid = localFenxiao.fenxiao.cid;
					this.moneyArea = localFenxiao.moneyArea;
				}
				setTimeout("localStorage.removeItem('fenxiao')",20*1000) 
				this.provinceData();  		//省份数据
				this.getlistData();			//路书分销列表
				this.getactiveData();		//活动分销列表
				this.created();				//滚动加载
				this.lineProfit();			//路书收益列表
				this.activityProfit();		//活动收益列表
				this.customerData();		//客户管理
				this.getVersionCode();
			}
			
			// var now = new Date(); // 当前日期
			// var nowDay = now.getDate(); // 当前日
			// var nowMonth = now.getMonth();  // 当前月
			// var nowDayOfWeek = now.getDay(); // 当前周
			// var day = nowDayOfWeek || 7;
			// console.log(this.formatDate(now)) //格式化当前日
			// console.log(this.formatDate(new Date(now.getFullYear(), nowMonth, nowDay + 7 - day)))	//本周末
			// console.log(this.formatDate(new Date(now.getFullYear(), nowMonth, nowDay + 7 - day + 1)))	//下周一
			// console.log(this.formatDate(new Date(now.getFullYear(), nowMonth, nowDay + 7 - day + 7)))	//下周末
		},
		methods:{
			formatDate(date) {
				var myyear = date.getFullYear();
				var mymonth = date.getMonth() + 1;
				var myweekday = date.getDate();
				if (mymonth < 10) {
					mymonth = "0" + mymonth;
				}
				if (myweekday < 10) {
					myweekday = "0" + myweekday;
				}
				return (myyear + "-" + mymonth + "-" + myweekday);
			},
			showPopup(){
				this.$dialog({
					message: '客户完成消费后5~10工作日自动结算，若客户取消订单，待结算收益可能减少' ,
					confirmButtonColor:'#5f6b80',
					confirmButtonText:'知道了',
					theme: 'round-button',
				});
			},
			getVersionCode (){
				function GetQueryString(name) {
					var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
					var r = window.location.search.substr(1).match(reg);
					if(r!=null)
					return unescape(r[2]);
					return null;
				}	
				this.versionCode = GetQueryString('versionCode');//从=号后面的内容

			},
			
			created(){
				var that = this;
				window.onscroll = function(){
				//变量scrollTop是滚动条滚动时，距离顶部的距离
				var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
				//变量windowHeight是可视区的高度
				var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
				//变量scrollHeight是滚动条的总高度
				var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
					//滚动条到底部的条件
					if(scrollTop+windowHeight+50>=scrollHeight){
						//写后台加载数据的函数
						// console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight);
						if (that.indexactive == 0) {
							console.log(that.fenxiao.page, that.fenxiao.maxPage);
							if (that.fenxiao.page < that.fenxiao.maxPage) {
								that.fenxiao.page ++ ;
								that.fenxiao.theEnd = false;
								that.getlistData();
								that.getactiveData();
							} else {
								that.fenxiao.theEnd = true;
								return false;
							}
						} else if (that.indexactive == 1) {
							if (that.profitactive == 0) {
								console.log(that.lineprofit.page, that.lineprofit.maxPage);
								if (that.lineprofit.page < that.lineprofit.maxPage) {
									that.lineprofit.page ++ ;
									that.lineprofit.theEnd = false;
									that.lineProfit();
								} else {
									that.lineprofit.theEnd = true;
									return false;
								}
							} else {
								if (that.activityProfit.page < that.activityProfit.maxPage) {
									that.activityProfit.page ++ ;
									that.activityProfit.theEnd = false;
									that.activityProfit();
								} else {
									that.activityProfit.theEnd = true;
									return false;
								}
							}
						} else if (that.indexactive == 2) {
							if (that.customer.page < that.customer.maxPage) {
								that.customer.page ++ ;
								that.customer.theEnd = false;
								that.customerData();
							} else {
								that.customer.theEnd = true;
								return false;
							}
						}
						// 判断是否是json
					}   
				}
			},
			onSearch(){
				let keyword = this.searchValue;
				this.fenxiao.word = keyword;
				this.fenxiao.page = 1;
				this.fenxiao.listData = [];
				this.fenxiao.activityData = [];
				if(this.fenxiao.type=="0"){
					this.getlistData();
				}else if(this.fenxiao.type=="1"){
					this.getactiveData();
				}
				
			},
			onCancel(){
				this.fenxiao.word = '';
				this.fenxiao.page = 1;
				this.fenxiao.listData = [];
				this.fenxiao.activityData = [];
				if(this.fenxiao.type=="0"){
					this.getlistData();
				}else if(this.fenxiao.type=="1"){
					this.getactiveData();
				}
			},
			// 选择分类
			typeChange(value){
				console.log(this.fenxiao.type)
				console.log(value)
				this.fenxiao.listData = [];
				this.fenxiao.activityData = [];
				this.fenxiao.page = 1;
				this.moneyArea = 'default';
				if(value==0){
					this.getlistData();
				}else if(value == 1){
					this.getactiveData();
				}
				// this.fenxiao.cid = 'default'
			},
			//选择省份 
			cityChange() {
				this.fenxiao.listData = [];
				this.fenxiao.activityData = [];
				this.fenxiao.page = 1;
				if(this.fenxiao.type=="0"){
					this.getlistData();
				}else{
					this.getactiveData();
				}
			},
			saveToLocal() {
				localStorage.setItem('fenxiao', JSON.stringify({fenxiao:this.fenxiao,moneyArea:this.moneyArea}));
			},
			//选择价格区间
			moneyChange(value) {
				console.log(value)
				this.moneyArea = value;
				this.fenxiao.listData = [];
				this.fenxiao.activityData = [];
				this.fenxiao.page = 1;
				if(this.fenxiao.type=="0"){
					this.getlistData();
				}else{
					this.getactiveData();
				}
				
			},
			
			// 省份数据
			provinceData() {
				let that=this;
				this.$get('/v2/api/w/distribution/info/province_list',{
					// type: that.fenxiao.type == 0 ? 1 : 2,
				}).then(function(res) {
					if(res.code==1000){
						console.log(res)
						var allProvince = res.data.map(item => {return {value: item.cid,text:item.cname}});
						var tempProvince = [{
								text: '出发地',
								value: 'default'
							}
						]
						that.fenxiao.province = tempProvince.concat(allProvince)
					}
				}).catch(
					function(res) {
						console.log(res);
					}
				)
			},
			// 路书分销
			getlistData() {
				let that=this;
				let param = {};
				if (that.fenxiao.cid && that.fenxiao.cid != 'default') {
					param.province = that.fenxiao.cid;
				}
				if (that.moneyArea && that.moneyArea != 'default') {
					param.sort = that.moneyArea;
				}
				param.page = that.fenxiao.page;
				param.size = that.fenxiao.size;
				param.word = that.fenxiao.word;
				
				this.$get('/v2/api/w/distribution/line/line_list', param).then(function(res) {
					if(res.code==1000){
						console.log(res)
						that.fenxiao.listData.push(...res.data.list)
						that.fenxiao.maxPage = res.data.page.maxPage
						that.fenxiao.page = res.data.page.currentPage
					}
				}).catch(
					function(res) {
						console.log(res);
					}
				)
			},
			// 活动分销
			getactiveData() {
				let that=this;
				var now = new Date(); // 当前日期
				var nowDay = now.getDate(); // 当前日
				var nowMonth = now.getMonth();  // 当前月
				var nowDayOfWeek = now.getDay(); // 当前周
				var day = nowDayOfWeek || 7;
				var time;
				var url;
				let param = {};
				if (that.fenxiao.cid && that.fenxiao.cid != 'default') {
					param.province = that.fenxiao.cid;
				}
				if (that.moneyArea && that.moneyArea != 'default' && (that.moneyArea=='asc'||that.moneyArea=='desc')) {
					param.sort = that.moneyArea;
					url = '/v2/api/w/distribution/activity/activity_list'
				}else{
					if(that.moneyArea=="thisweek" && that.moneyArea != 'default'){
						time = that.formatDate(now) + ',' + that.formatDate(new Date(now.getFullYear(), nowMonth, nowDay + 7 - day))
					}else if(that.moneyArea=="nextweek" && that.moneyArea != 'default'){
						time = that.formatDate(new Date(now.getFullYear(), nowMonth, nowDay + 7 - day + 1)) + ',' + that.formatDate(new Date(now.getFullYear(), nowMonth, nowDay + 7 - day + 7))
					}else if(that.moneyArea=="duanwu" && that.moneyArea != 'default'){
						time = '2021-06-12,2021-06-14'
					}else{
						time = ''
					}
					url = '/v2/api/w/distribution/activity/activity_list?time='+ time
				}

				param.page = that.fenxiao.page;
				param.size = that.fenxiao.size;
				param.word = that.fenxiao.word;

				this.$get(url, param).then(function(res) {
					if(res.code==1000){
						console.log(res)
						that.fenxiao.activityData.push(...res.data.list)
						that.fenxiao.maxPage = res.data.page.maxPage
						that.fenxiao.page = res.data.page.currentPage
						that.saveToLocal();
					}
				}).catch(
					function(res) {
						console.log(res);
					}
				)
			},
			// 打电话
			goTel(mobile){
				if(this.device=='ios'){
					window.webkit.messageHandlers.appGoTel.postMessage({mobile:mobile});
					return;
				}else if(this.device=='android'){
					try {
						if (typeof(eval('window.ahatripApp.appGoTel'))=="function") {
							eval("window.ahatripApp.appGoTel(JSON.stringify({mobile:mobile}))");
							return;
						}
					} catch(e) {
						eval("appGoTel.postMessage(JSON.stringify({mobile:mobile}))");
					}
				}else{
					window.location.href='tel:'+ mobile;
				}
			},
			// 去分销
			gofenxiao(id) {
				this.$router.push({
					path:"/line/details/"+ id+'?_from=' + this.device,
					query: {
						shareType: 'shareType'
					},
				});
			},
			goshare(id){
				window.location.href = `${process.env.VUE_APP_MAIN_DOMAIN}?m=activity&a=view&id=${id}&type=share_fenxiao&_from=${this.device}`
			},
			// 我的收益 路书收益
			lineProfit(){
				let that=this;
				let param = {};
				param.page = that.lineprofit.page;
				param.size = that.lineprofit.size;
				this.$get('/v2/api/w/distribution/line/profit_of_line',param).then(function(res) {
					if(res.code==1000){
						console.log(res,res.data.profit)
						that.lineprofit.maxPage = res.data.page.maxPage
						that.lineprofit.page = res.data.page.currentPage
						that.lineprofit.list.push(...res.data.list)
						// if (res.data.profit) {
						// 	console.log(res.data.profit)
						// 	that.lineprofit = res.data.profit
						// 	that.lineprofit.list = res.data.list
						// }
					}
				}).catch(
					function(res) {
						console.log(res);
					}
				)
			},
			// 活动收益
			activityProfit(){
				let that=this;
				let param = {};
				param.page = that.activityprofit.page;
				param.size = that.activityprofit.size;
				this.$get('/v2/api/w/distribution/activity/profit_of_activity', param).then(function(res) {
					if(res.code==1000){
						console.log(res)
						if(res.data.profit){
							that.profit = res.data.profit
						}
						that.activityprofit.maxPage = res.data.page.maxPage
						that.activityprofit.page = res.data.page.currentPage
						that.activityprofit.list.push(...res.data.list)
						// if (res.data.profit) {
						// 	console.log(res.data.profit)
						// 	that.activityprofit = res.data.profit
						// 	that.activityprofit.list = res.data.list
						// }
					}
				}).catch(
					function(res) {
						console.log(res);
					}
				)
			},
			// 客户管理
			customerData(){
				let that=this;
				let param = {};
				param.page = that.customer.page;
				param.size = that.customer.size;
				this.$get('/v2/api/w/distribution/line/my_customer', param).then(function(res) {
					if(res.code==1000){
						console.log(res)
						// that.customer.list = res.data.list
						that.customer.list.push(...res.data.list)
						that.customer.maxPage = res.data.page.maxPage
						that.customer.page = res.data.page.currentPage
					}
				}).catch(
					function(res) {
						console.log(res);
					}
				)
			},
			// 路书收益跳转
			goInfoDetail(type, id){
				this.$router.push({
					path:"/fenxiao/profit_list",
					query: {
						profitType: type,
						id: id
					},
				});
			},
			// 联系他
			goChat(uid,nickName){
				var upGradeUrl = 'http://a.app.qq.com/o/simple.jsp?pkgname=lushu.xoosh.cn.xoosh&fromcase=40003';
				var param = {
					uid:uid,	//有uid进入单聊
					nickName:nickName,
				}
				if(this.device === 'android'){
					window.ahatripApp.appGoChat(param);
				}else if(this.device === 'ios'){
					window.webkit.messageHandlers.appGoChat.postMessage(param);
				}else{
					window.location.href = upGradeUrl;
				}
			},
			// 在线客服
			goKefu(){
				var upGradeUrl = 'http://a.app.qq.com/o/simple.jsp?pkgname=lushu.xoosh.cn.xoosh&fromcase=40003';
				if(this.device === 'android'){
					window.ahatripApp.appGoKeFu(123);
				}else if(this.device === 'ios'){
					window.webkit.messageHandlers.appGoKeFu.postMessage(123);
				}else{
					window.location.href = upGradeUrl;
				}
			},
			// 去提现			
			goWallet(){
				this.$dialog({
					message: '正在维护中，如有需要请联系客服' ,
					confirmButtonColor:'#5f6b80',
					confirmButtonText:'知道了',
					theme: 'round-button',
				});
				// let param = {
				// 	"values": {},
				// 	"viewpage": "AhaWalletPageViewController"
				// }
				// if(this.device == 'android'){
				// 	if(this.versionCode >= '2.9.5'){
				// 		window.ahatripApp.appGoViewPage(JSON.stringify(param));
				// 	}else{
				// 		window.location.href = `${process.env.VUE_APP_MAIN_DOMAIN}?m=mybill&a=mywallet`
				// 	}
				// }else if(this.device == 'ios'){
				// 	if(this.versionCode >= '2.9.5'){
				// 		window.webkit.messageHandlers.appGoViewPage.postMessage(JSON.stringify(param));
				// 	}else{
				// 		window.location.href = `${process.env.VUE_APP_MAIN_DOMAIN}?m=mybill&a=mywallet`
				// 	}
				// }else{
				// 	window.location.href = `${process.env.VUE_APP_MAIN_DOMAIN}?m=mybill&a=mywallet`
				// }
			},
		},
	};
</script>


<style scoped>
	/deep/.van-tab--active{
		font-weight: 800;
	}
	/deep/.van-dropdown-menu__bar{
		box-shadow: initial;
	}
	.choice{
		position: fixed;
		width: 100%;
		top: 85px;
		left: 0;
		z-index: 10;
	}
	.content{
		background: #fff;
		padding: 0 15px;
		margin-top: 90px;
	}
	.explain{
		display: flex;
		align-items: center;
		font-size: 13px;
		margin-top: 10px;
		color: #5f6b80;
	}
	.explain img{
		width: 20px;
		margin-right: 5px;
	}
	.bottom_text{
		font-size: 13px;
		color: #A8AAAD;
		margin: 20px 0;
		display: flex;
		align-items: center;
		justify-content: center; 
	}
	.bottom_text img{
		width: 15px;
		margin: 0 7px;
	}
	.line{
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 15px 0;
		border-bottom: 1.3px solid #e1e1e1;
	}
	.line .left{
		flex: 1;
		margin-right: 10px;
	}
	.line h1{
		font-size: 15px;
		color: #39393F;
		line-height: 21px;
		margin-bottom: 15px;
	}
	.btn{
		border: 1.3px solid rgba(95,107,128,0.6);
		border-radius: 15px;
		font-size: 14px;
		color: #5F6B80;
		padding: 5px 10px;
		text-align: center;
	}
	.line .bottom{
		display: flex;
		align-items: center;
	}
	.right p{
		font-size: 11px;
		color: #848689;
		text-align: center;
		margin-top: 3px;
	}
	.bottom img{
		width: 20px;
	}
	.bottom p{
		font-size: 12px;
		margin-right: 10px;
	}
	.bottom .money{
		color: #606B80;
	}
	.bottom b{
		font-size: 15px;
	}
	.bottom span{
		font-size: 10px;
		color: #46837B;
		border: 1.1px solid rgba(70,131,123,0.6);
		border-radius: 10px;
		padding: 1.1px 5px;
		margin-right: 10px;
	}
	.bottom .num{
		color: #46837B;
	}
	.profit{
		padding: 15px;
		background: #5F6B80;
		position: relative;
		text-align: center;
	}
	.profit .button{
		background-image: linear-gradient(90deg, #3BB3A4 0%, #3AAF81 100%);
		box-shadow: 0 2px 10px 0 rgba(74,84,102,0.60);
		border-radius: 6px;
		margin: 7px auto 10px;
		width: 130px;
		text-align: center;
		padding: 10px 0;
		font-size: 14px;
		color: #FFFFFF;
	}
	.profit p{
		font-size: 13px;
		color: #D6DFEE;
		margin: 7px 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.profit p img{
		position: relative;
		width: 20px;
		margin-left: 10px;
	}
	.profit h1{
		font-size: 35px;
		color: #fff;
	}
	.profit img{
		position: absolute;
		right: 0;
		top: 0;
		width: 65px;
	}
	.profit_content{
		padding: 0 15px;
	}
	.profit_bottom{
		display: flex;
		align-items: center;
		font-size: 14px;
		color: #848689;
	}
	.profit_bottom .money{
		color: #003500;
	}
	.profit_bottom img{
		width: 15px;
	}
	.customer{
		padding: 0 15px;
	}
	.customer line{
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-bottom: 1.1px solid #e1e1e1;
	}
	.customer .center{
		flex: 1;
		margin: 0 15px;
	}
	.customer img{
		border-radius: 50%;
		width: 60px;
		height: 60px;
	}
	.customer p{
		font-size: 14px;
		color: #848689;
		margin: 10px 0;
	}
	.customer b{
		font-size: 16px;
		color: #39393F;
	}
	.customer .btn{
		border: 1.1px solid rgba(95,107,128,0.6);
		border-radius: 15px;
		font-size: 14px;
		color: #5F6B80;
		padding: 5px 15px;
	}
	.fenxiao_img{
		margin: 15px 15px 0;
	}
	.fenxiao_img img{
		width: 100%;
	}
	.none{
		text-align: center;
		color: #848689;
		font-size: 14px;
	}
	.none img{
		width: 40%;
		margin: 20px 0;
	}
	/deep/.van-collapse-item__content{
		font-size: 15px;
		line-height: 30px;
	}
</style>
